import { delay } from "@/lib/mockUtils";

export const requestPasswordResetMock = async (email: string) => {
  console.log("Mock: Requesting password reset for:", email);
  await delay(1000); // Simulate network delay
  // Simulate success for any email for now
  return Promise.resolve();
};
